import { render, staticRenderFns } from "./ui-color.vue?vue&type=template&id=21a8d6d5&lang=pug&"
import script from "./ui-color.vue?vue&type=script&lang=js&"
export * from "./ui-color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21a8d6d5')) {
      api.createRecord('21a8d6d5', component.options)
    } else {
      api.reload('21a8d6d5', component.options)
    }
    module.hot.accept("./ui-color.vue?vue&type=template&id=21a8d6d5&lang=pug&", function () {
      api.rerender('21a8d6d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/ui-pages/ui-color.vue"
export default component.exports